import React from 'react';
import './UpperLoader.css'; // Asegúrate de importar el archivo CSS

const UpperLoader = () => {
  return (
    <div className="loader-container">
      <div className="loader"></div>
    </div>
  );
};

export default UpperLoader;
